import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submitter"];
  static values = { linkClicked: { type: Boolean, default: false } };

  disableSubmitter() {
    this.submitterTarget.disabled = true;
  }

  // 2回目以降のクリックを無効化する
  disableLink(e) {
    if (this.linkClickedValue) {
      e.preventDefault();
    } else {
      this.linkClickedValue = true;
    }
  }
}
